import React from 'react';

import { useCallbackRef } from '../use-callback-ref';
/**
 * React hook that is used as declarative interface to `setTimeout`
 *
 * @param callback the callback function that is executed after a specific delay
 * @param delay the delay in milliseconds
 */
export const useTimeout = (
  callback: (...args: unknown[]) => void,
  delay: number | null | undefined
) => {
  const callbackRef = useCallbackRef(callback);

  React.useEffect(() => {
    if (delay === null || delay === undefined) return undefined;

    const timeout = window.setTimeout(() => callbackRef(), delay);

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [callbackRef, delay]);
};

export default useTimeout;
